import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { UntilDestroy } from '@ngneat/until-destroy'
import { NzCardModule } from 'ng-zorro-antd/card'
import { NzDrawerModule } from 'ng-zorro-antd/drawer'
import { NzLayoutModule } from 'ng-zorro-antd/layout'
import { NzMenuModule } from 'ng-zorro-antd/menu'
import { NzSpaceModule } from 'ng-zorro-antd/space'
import { Observable } from 'rxjs'
import { filter } from 'rxjs/operators'
import { AtomModule } from '../../atom/atom.module'
import { FooterComponent } from '../../molecule/footer/footer.component'
import { SearchBannerComponent } from '../../molecule/search-banner/search-banner.component'
import { CartService } from '../../service/cart.service'
import { CurrencyLocalePipe } from '../../utils/pipes/currency-locale.pipe'

@UntilDestroy()
@Component({
  selector: 'app-layout-beta',
  templateUrl: './layout-beta.component.html',
  styleUrls: ['./layout-beta.component.less'],
  standalone: true,
  imports: [
    AtomModule,
    NzLayoutModule,
    NzMenuModule,
    NzSpaceModule,
    NzDrawerModule,
    NzCardModule,
    SearchBannerComponent,
    FooterComponent,
    CurrencyLocalePipe,
  ],
})
export class LayoutBetaComponent implements AfterViewInit {
  @ViewChild('hexa') hexaElement!: ElementRef;
  @ViewChild('content') contentElement!: ElementRef;
  items$: Observable<number> = this.cartService.getCartItemCount()
  showSideMenuDrawer = false
  isSideMenuDrawerVisible = false
  isCartDropdownVisible = false
  isCartDrawerVisible = false

  ngAfterViewInit(): void {
    this.updateContentElement();
    this.updateHexaElement();
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateHexaElement();
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateContentElement();
    this.updateHexaElement();
  }

  // New method to update the hexa element content
  updateHexaElement(): void {
    this.hexaElement.nativeElement.style.height = `1px`;
    setTimeout(() => {
      const hexDocumentHeight = document.documentElement.scrollHeight;
      this.hexaElement.nativeElement.style.height = `${hexDocumentHeight}px`;
    }, 500);
  }

  updateContentElement(): void {
    setTimeout(() => {
      const contentDocumentHeight = window.innerHeight;
      console.log({contentDocumentHeight});
      this.contentElement.nativeElement.style.minHeight = `${contentDocumentHeight}px`;
    }, 0);
  }

  constructor(
    private cartService: CartService,
    private route: Router
  ) {}

  get isHomePage(): boolean {
    return this.route && this.route.url.includes('home')
  }

  changeSideMenuDrawer(isVisible: boolean): void {
    this.isSideMenuDrawerVisible = isVisible
  }
}
